import { use } from 'react';
import { styled } from '@mui/material/styles';
import { imgSrc } from './utils/imageUtils';

const StyledImage = styled('img')({
  objectFit: 'scale-down',
});

export const Image = ({ src = '', ...props }: React.ComponentProps<'img'>) => {
  src = use(imgSrc(src));

  return <StyledImage src={src} {...props} />;
};
